import React, { Component } from "react";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm, SubmissionError } from 'redux-form';
import { Checkbox } from "components/Forms"
import { boolean } from "util/selectValues";

import Sidebar from "components/Sidebar";
import { requestDeleteTreatmentSite, requestTreatmentSite } from 'modules/treatmentSite/actions';
import { getQueryVariables } from 'util/index';

import { _required, _email, _mobile } from "util/validation"
let required = _required();
const requireYes = value => value === 'true' ? undefined : 'You must select "Yes" to delete the treatmentSite.';

function mapStateToProps(state) {
  return {
    treatmentSite: state.treatmentSites.current,
  };
}


function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    requestDeleteTreatmentSite,
    requestTreatmentSite
  }, dispatch);
}


class TreatmentSiteDelete extends Component {

  componentWillMount() {
    const { id } = getQueryVariables(window.location.search);
    this.props.requestTreatmentSite({query: id, callback: () => {
      this.props.reset();
    }});
    this.setState({ treatmentSiteId: id });
  }

  submit(_results) {
    return new Promise((resolve, reject) => {

      if (_results.confirmDelete !== "true") {
        return reject(new SubmissionError({
          confirmDelete: 'You must select "Yes" to delete the treatmentSite.'
        }));
      }

      this.props.requestDeleteTreatmentSite({
        id: this.props.treatmentSite.id,
        callback: (result) => {
          if (!result.error) {
            this.props.history.push(`/treatment/success?type=delete`)
            return resolve();
          } else {
            return reject(new SubmissionError({
              _error: result.error.message
            }));
          }
        }
      });
    });
  }

  render() {
    if (!this.props.treatmentSite.id) {
      return "";
    }
    return (
      <main className={"dashboard details-page"}>
        <Sidebar />
        <div className="content">
          <div className='default-form'>
            <h1>Delete Treatment Site</h1>
            <p>Treatment Site: {this.props.treatmentSite.name}</p>
            <p>This will delete the treatment site.</p>
              <form onSubmit={this.props.handleSubmit(results => this.submit(results))} autoComplete="off">
              <Checkbox validate={[required, requireYes]} radio title="Do you wish to continue?" styling="float r" name="confirmDelete" options={boolean} />
              <div className="navigation">
                <button type="submit" className="button-type-1">Delete</button>
              </div>
            </form>
          </div>
        </div>
      </main>
    )
  }
}

TreatmentSiteDelete = reduxForm({
  form: 'TreatmentSiteDelete' // a unique name for this form
})(TreatmentSiteDelete);

export default connect(mapStateToProps, mapDispatchToProps)(TreatmentSiteDelete);
